import { Injectable, signal } from '@angular/core';
import { Link } from '@app/core/models/atomics.model';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private _links = signal<Link[]>([]);

  links = this._links.asReadonly();

  setLinks(links: Link[]): void {
    this._links.set(links);
  }

  addLink(link: Link): void {
    this._links.set([...this.links(), link]);
  }

  clearLinks(): void {
    this._links.set([]);
  }
}
